import { batch } from 'react-redux';
import { setAllFields, setFields } from 'fields';
import { setResourceLoaded } from 'loading';
import { resourceType } from 'constants/loading';

export const processAllFields = ({ dispatch, fields }) => {
  return Promise.resolve()
  .then( () => {
    dispatch(setAllFields(fields));
    return fields;
  });
};

export const processFields = async ({ dispatch, fields, operationsIds }) => {
  // TODO: remove batch usage after upgrading to React 18 (https://react-redux.js.org/api/batch)
  batch(() => {
    dispatch(setFields(fields));
    operationsIds.forEach((id) => {
      dispatch(setResourceLoaded({ type: resourceType.FIELDS_BY_OPERATION_ID, id }));
    });
  });
  return fields;
};
